// On dev.edufocalacademy.com, prefix every document.title with "[Dev] " so
// the browser tab strip shows which environment a tab is on at a glance.
// Hostname-based check: no env var required, no risk of leaking onto prod.
//
// Implementation: replace the document.title property descriptor so any
// future write (from useEffect, react-helmet, third-party libs, etc.) is
// transparently prefixed.

const PREFIX = "[Dev] ";

export function installDevTitlePrefix(): void {
  if (typeof window === "undefined") return;
  if (!window.location.hostname.startsWith("dev.")) return;

  const proto = Object.getOwnPropertyDescriptor(Document.prototype, "title");
  if (!proto?.set || !proto?.get) return;

  Object.defineProperty(document, "title", {
    set(value: string) {
      const v = value ?? "";
      const next = v.startsWith(PREFIX) ? v : `${PREFIX}${v}`;
      proto.set!.call(this, next);
    },
    get() {
      return proto.get!.call(this);
    },
    configurable: true,
  });

  // Re-apply to whatever the static index.html initial title was so the
  // first paint also shows the prefix.
  // eslint-disable-next-line no-self-assign
  document.title = document.title;
}
